// src/pages/MPFlow/phases/Phase4Segmentation.jsx
import React from 'react';
import EdyMascot from '../components/EdyMascot';
import EddySegmentation from '../components/EddySegmentation';

export default function Phase4Segmentation({ profile, creation, refinement, onNext, onBack }) {
  const handleComplete = (targeting) => {
    onNext({ targeting });
  };

  return (
    <div>
      <EdyMascot phase="segmentacao" />
      <div className="mp-card">
        <h2 className="mp-phase-title">Segmentação do Anúncio</h2>
        <p className="mp-phase-sub">Defina quem verá seu anúncio no Facebook e Instagram.</p>

        <EddySegmentation profile={profile} onComplete={handleComplete} />

        <div className="mp-btn-row mp-mt-5">
          {onBack && (
            <button className="mp-btn mp-btn--ghost mp-btn--sm" onClick={onBack}>
              ← Voltar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
